import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[url]/page.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/faqComponent/faqComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/lazyCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/singleBlogView/singleBlogView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/Footer/Footer.tsx");
